
    import {Component, Vue} from "vue-property-decorator";
    import {currentUserModule} from "@/store";
    import OkDialog from "@/components/common/OkDialog.vue";

    @Component({
        name: 'Account',
        components: {
            OkDialog
        },
    })
    export default class Account extends Vue {
        passwordOld: string = "";
        passwordNew1: string = "";
        passwordNew2: string = "";
        showOldPassword: boolean = false;
        showNewPassword: boolean = false;
        valid: boolean = false;
        rules: any = {
            required: (v: any) => !!v || 'Wird Benötigt.',
            min: (v: any) => v.length >= 6 || 'Mindestens 6 Zeichen',
            uppercase: (v: any) => (/[A-Z]/.test(v)) || 'Mindestens 1 Großbuchstaben',
            lowercase: (v: any) => (/[a-z]/.test(v)) || 'Mindestens 1 Kleinbuchstabe',
            number: (v: any) => (/[0-9]/.test(v)) || 'Mindestens eine Zahl',
        };
        showOkDialog: boolean = false;
        okDialogHeadline: string = "";
        okDialogText: string = "";

        get passwordIsOkToChange() {
            // TODO fancy password change rules
            return this.valid &&
                this.passwordOld != null && this.passwordOld.length > 0 &&
                this.passwordNew1 != null && this.passwordNew1.length > 0 &&
                this.passwordOld !== this.passwordNew1 &&
                (this.showNewPassword ||
                    (this.passwordNew2 != null && this.passwordNew2.length > 0 &&
                        this.passwordNew1 === this.passwordNew2));
        }

        get username() {
            return currentUserModule.user?.userName;
        }


        get displayName() {
            return currentUserModule.user?.displayName;
        }


        get role() {
            return currentUserModule.user?.role?.displayName;
        }

        async mounted() {
            await currentUserModule.load()
        }


        ruleOtherPassword(value: any) {
            return value !== this.passwordOld || 'Das alte und neue Passwort muss unterschiedlich sein'
        }

        ruleSamePassword(value: any) {
            return value === this.passwordNew1 || 'Neue Passwörter müssen gleich sein'
        }

        async changePassword() {
            const result = await currentUserModule.changePassword({
                oldPassword: this.passwordOld,
                newPassword: this.passwordNew1
            });

            if (result) {
                this.okDialogHeadline = "Passwortänderung erfolgreich"
                this.okDialogText = "Sie haben ihr Passwort erfolgreich geändert und können es bei der nächsten Anmeldung verwenden."
            } else {
                this.okDialogHeadline = "Passwortänderung fehlgeschlagen"
                this.okDialogText = "Bitte überprüfen Sie Ihr eingegebens Passwort."
            }
            this.showOkDialog = true;
        }
    }
